import City from 'model/political/city';

const passiveControl = (cityName, controlType) => {
  const amount = controlType === City.StatusInTown.Dominant ? 50 : controlType === City.StatusInTown.Familiar ? 5 : 0;
  return {
    enabled: () => true,
    type: cityName,
    execute: context => {
      const { party } = context;
      const coins = amount;
      const food = amount;
      const water = amount;
      const ammo = amount;

      party.resources.delta({ coins, food, water, ammo }, context);

      return { gain: { coins, food, water, ammo } };
    },
    effects: () => ({
      coins: amount,
      food: amount,
      ammo: amount,
      water: amount
    })
  };
};

export default passiveControl;
